import { Component, Injector, OnInit } from '@angular/core';
import { ActiveModal, ChassisFormHandler, TenantModel } from '@kaiser-software/chassis-core';
import { LocationModal } from '../location-modal';
import 'rxjs/add/observable/of';
import { Observable } from 'rxjs/Observable';

@Component({
    selector: 'eyewatch-locations-create-modal',
    templateUrl: 'create-location.modal.html',
    styleUrls: [ 'create-location.modal.scss' ]
})
export class CreateLocationModal extends LocationModal implements OnInit {

    private title = 'Add location';

    public pluginData = {};

    constructor(protected injector: Injector, protected modal: ActiveModal) {
        super(injector, modal);
    }

    ngOnInit() {
        const tenant = this.modal.get<TenantModel>('tenant');

        this.tenantLocationService.defaultParams = { tenant: tenant.id };

        this.model = this.tenantLocationService.make();

        super.ngOnInit();

        this.modal.set('title', this.title);

        this.createForm();

        this.pluginData = {
            inputs: {
                modelSubject: Observable.of(this.model),
                form: this.form,
            }
        };
    }

    private createForm(): void {
        this.form = new ChassisFormHandler(this.injector, this.tenantLocationService.entityName, this.model);
    }

    protected setModalButtons() {
        super.setModalButtons();
    }

    protected setSubmitModalButton(buttons: Map<string, any>) {
        super.setSubmitModalButton(buttons);
    }

}



// WEBPACK FOOTER //
// ./apps/eyewatch/src/app/eyewatch/locations/modals/create-location/create-location.modal.ts